import React from 'react'
import AppRouter from './app.router'
import { Provider } from 'react-redux'
import ToastComponentController from './contexts/toast.control'
import ApiServiceProvider from './services/api/api.service'
import AxiosProvider from './services/interceptor/interceptor'
import SpinnerProvider from './components/spinner/spinner'
import store from './store/store'
import Notification from './utils/notification'
import { Helmet, HelmetProvider } from 'react-helmet-async'



// Sass css start
    import './assetsSass/img/favicon.ico'
    import './assetsSass/css/bootstrap.min.css' 
    import './assetsSass/plugins/fontawesome/css/fontawesome.min.css'
    import './assetsSass/plugins/fontawesome/css/all.min.css'
    import './assetsSass/css/style.css'
    import './assetsSass/css/feather.css'
    import './assetsSass/plugins/datatables/datatables.min.css'
    import './assetsSass/plugins/icons/truck-icon.css'

    import './assetsSass/js/jquery-3.7.1.min.js'
    import './assetsSass/js/bootstrap.bundle.min.js'
    import './assetsSass/js/script.js'
    import './assetsSass/js/feather.min.js'
    import './assetsSass/plugins/slimscroll/jquery.slimscroll.min.js'
    import './assetsSass/plugins/datatables/jquery.dataTables.min.js'
    import './assetsSass/plugins/datatables/datatables.min.js'

// Sass css end

const App = () => {
  return (
    <>
      <Provider store={store}>
        <HelmetProvider>
          <SpinnerProvider>
            <ToastComponentController>
              <AxiosProvider>
                <ApiServiceProvider>
                  <AppRouter />
                  {/* <Notification /> */}
                </ApiServiceProvider>
              </AxiosProvider>
            </ToastComponentController>
          </SpinnerProvider>
        </HelmetProvider>
      </Provider>
    </>
  )
}

export default App
